import { PlayerManager } from '../playerManager';
import { ICaptionsItem } from '../../../../types/common';
import { EPlayerControllerMode, PlayerController } from '../playerController';
import { PlayerProvider } from '../../provider/playerProvider';

export class PlayCaptionCommandHandler {

  public async playNext() {
      const playerProvider = PlayerProvider.getProvider();

      const captions: ICaptionsItem[] = playerProvider.getTargetCaptions();
      let currentIndex = await playerProvider.getActiveTargetCaptionIndex();
      currentIndex++;
      if (currentIndex >= captions.length) return;
      this.playCaption(currentIndex, captions, EPlayerControllerMode.PLAY_CAPTION);
  }

  public async playPrev() {
      const playerProvider = PlayerProvider.getProvider();
      const captions: ICaptionsItem[] = playerProvider.getTargetCaptions();
      let currentIndex = await playerProvider.getActiveTargetCaptionIndex();

      if (currentIndex < 0 || currentIndex >= captions.length) return;
      const index = currentIndex > 0 ? currentIndex - 1 : 0;

      this.playCaption(index, captions, EPlayerControllerMode.PLAY_CAPTION);
  }

  public async repeat() {
    const playerProvider = PlayerProvider.getProvider();
    const captions: ICaptionsItem[] = playerProvider.getTargetCaptions();
    let currentIndex = await playerProvider.getActiveTargetCaptionIndex();
      if (currentIndex < 0 || currentIndex >= captions.length) return;
      if (playerProvider.isPaused() && currentIndex > 0) {
        currentIndex--;
      }
      this.playCaption(currentIndex, captions, EPlayerControllerMode.PLAY_CAPTION);
  }

  public async resumePlay() {
    const playerManager = PlayerManager.getInstance();
    const captions: ICaptionsItem[] = playerManager.getTargetCaptions();
    let currentIndex = await playerManager.getActiveTargetCaptionIndex();
    if (currentIndex >= captions.length) return;
    if (currentIndex < 0) currentIndex = 0;
    await playerManager.startPlay();
    playerManager.setTimer(captions[currentIndex].endTime);
  }

  private playCaption(index: number, captions: ICaptionsItem[], mode: EPlayerControllerMode) {
    if (index >= 0 && index < captions.length) {
      const playerManager = PlayerManager.getInstance();
      playerManager.pausePlay();
      const caption = captions[index];
      const playerController = PlayerController.getInstance();
      if (mode === EPlayerControllerMode.PLAY_CAPTION) {
        playerController.playCaption(caption);
      } else {
        playerController.play(caption.startTime, index);
      }
    }
  }
}
